module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQiIGhlaWdodD0iNjYiIHZpZXdCb3g9IjAgMCA0NCA2NiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMzLjQgMC41TDQzLjEgMTAuM0wxOC44IDMzTDQzLjEgNTUuOEwzMy40IDY1LjVMMC45IDMzTDMzLjQgMC41WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/Galerija/FullScreen/chevron-left.svg
// module id = 1003
// module chunks = 132729432747416